var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageFallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 180,
    viewBox: "0 0 212 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 180,
    rx: 2,
    fill: "#EAECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 70H85.625C84.6636 70 83.7416 70.3819 83.0617 71.0617C82.3819 71.7416 82 72.6636 82 73.625V106.25C82 107.211 82.3819 108.133 83.0617 108.813C83.7416 109.493 84.6636 109.875 85.625 109.875H125.5C126.461 109.875 127.383 109.493 128.063 108.813C128.743 108.133 129.125 107.211 129.125 106.25V73.625C129.125 72.6636 128.743 71.7416 128.063 71.0617C127.383 70.3819 126.461 70 125.5 70ZM125.5 73.625V96.9043L119.594 91.0001C119.257 90.6634 118.857 90.3963 118.417 90.2141C117.978 90.0318 117.506 89.938 117.03 89.938C116.554 89.938 116.082 90.0318 115.643 90.2141C115.203 90.3963 114.803 90.6634 114.466 91.0001L109.935 95.5313L99.9664 85.5626C99.2867 84.8833 98.365 84.5017 97.404 84.5017C96.443 84.5017 95.5213 84.8833 94.8416 85.5626L85.625 94.7791V73.625H125.5ZM85.625 99.9062L97.4062 88.125L115.531 106.25H85.625V99.9062ZM125.5 106.25H120.658L112.502 98.0938L117.033 93.5625L125.5 102.031V106.25ZM109.188 83.5938C109.188 83.056 109.347 82.5304 109.646 82.0833C109.944 81.6362 110.369 81.2877 110.866 81.082C111.363 80.8762 111.909 80.8223 112.437 80.9272C112.964 81.0321 113.448 81.2911 113.829 81.6713C114.209 82.0515 114.468 82.536 114.573 83.0633C114.678 83.5907 114.624 84.1374 114.418 84.6342C114.212 85.131 113.864 85.5556 113.417 85.8543C112.97 86.153 112.444 86.3125 111.906 86.3125C111.185 86.3125 110.494 86.0261 109.984 85.5162C109.474 85.0063 109.188 84.3148 109.188 83.5938Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFallback);
export default __webpack_public_path__ + "static/media/image-fallback.4451ac26c641fd15a99f5211582e85dc.svg";
export { ForwardRef as ReactComponent };